module.exports = __webpack_public_path__ + "../resources/img/weather_snow.44c5dc7d.svg";